interface AlertItem {
  text: string;
  link?: string;
}

interface AlertsPanelProps {
  lowStockCount?: number;
  openNCRs?: number;
}

export default function AlertsPanel({ lowStockCount = 0, openNCRs = 0 }: AlertsPanelProps) {
  const criticalAlerts: AlertItem[] = [];
  if (openNCRs > 0) {
    criticalAlerts.push({ text: `Open Non-Conformance Reports (NCRs): ${openNCRs} requiring attention` });
  }

  const attentionAlerts: AlertItem[] = [];
  if (lowStockCount > 0) {
    attentionAlerts.push({ text: `${lowStockCount} items below minimum stock level (Reorder required)` });
  }

  const achievements: AlertItem[] = [
    { text: 'ERP System running cleanly with active database sync' },
  ];

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-xl p-5 h-full">
      <h3 className="text-sm font-semibold text-[#1e293b] mb-4 flex items-center gap-2">
        <i className="ri-notification-3-line text-red-500" />
        Alerts &amp; Action Items
      </h3>

      {/* Critical */}
      <div className="mb-4">
        <div className="flex items-center gap-1.5 mb-2">
          <span className="w-2 h-2 rounded-full bg-red-500" />
          <span className="text-xs font-semibold text-red-700 uppercase tracking-wider">Critical</span>
        </div>
        {criticalAlerts.length === 0 ? (
          <p className="text-xs text-emerald-600 pl-3.5">No critical alerts</p>
        ) : (
          <div className="space-y-1.5 pl-3.5">
            {criticalAlerts.map((a, i) => (
              <div key={i} className="flex items-start gap-2 p-2 bg-red-50 rounded-lg">
                <i className="ri-error-warning-fill text-red-500 text-xs mt-0.5 flex-shrink-0" />
                <span className="text-xs text-red-700">{a.text}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Attention */}
      <div className="mb-4">
        <div className="flex items-center gap-1.5 mb-2">
          <span className="w-2 h-2 rounded-full bg-amber-500" />
          <span className="text-xs font-semibold text-amber-700 uppercase tracking-wider">Attention Needed</span>
        </div>
        {attentionAlerts.length === 0 ? (
          <p className="text-xs text-[#64748b] pl-3.5">All good!</p>
        ) : (
          <div className="space-y-1.5 pl-3.5">
            {attentionAlerts.map((a, i) => (
              <div key={i} className="flex items-start gap-2 p-2 bg-amber-50 rounded-lg">
                <i className="ri-alert-fill text-amber-500 text-xs mt-0.5 flex-shrink-0" />
                <span className="text-xs text-amber-700">{a.text}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Achievements */}
      <div>
        <div className="flex items-center gap-1.5 mb-2">
          <span className="w-2 h-2 rounded-full bg-emerald-500" />
          <span className="text-xs font-semibold text-emerald-700 uppercase tracking-wider">Recent Achievements</span>
        </div>
        <div className="space-y-1.5 pl-3.5">
          {achievements.map((a, i) => (
            <div key={i} className="flex items-start gap-2 p-2 bg-emerald-50 rounded-lg">
              <i className="ri-checkbox-circle-fill text-emerald-500 text-xs mt-0.5 flex-shrink-0" />
              <span className="text-xs text-emerald-700">{a.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
